import React from 'react';
import PropTypes from 'prop-types';
import { withFocus } from '@accedo/vdkweb-navigation';

import categoryItemTheme from './elevateCategoryItem.scss';

const ElevateCategoryItem = ({
  containerStyle,
  data,
  nav,
  width,
  height,
  onClick
}) => {
  const wrapperClassName = `${categoryItemTheme.wrapper} ${
    nav.isFocused ? categoryItemTheme.focused : ''
  }`;

  const wrapperStyle = {
    ...containerStyle,
    ...(width ? { width } : {}),
    ...(height ? { height } : {})
  };

  return (
    <div
      className={wrapperClassName}
      style={wrapperStyle}
      onMouseOver={nav.onMouseOver}
      onMouseOut={nav.onMouseOut}
      onClick={onClick}
      role="button"
    >
      <div className={categoryItemTheme.title}>{data.title}</div>
    </div>
  );
};

ElevateCategoryItem.propTypes = {
  containerStyle: PropTypes.object,
  data: PropTypes.object,
  height: PropTypes.any,
  width: PropTypes.any,
  nav: PropTypes.object,
  onClick: PropTypes.func
};

export default withFocus(ElevateCategoryItem);
